import { render, staticRenderFns } from "./AdManagerAdmin.vue?vue&type=template&id=766d7cba"
import script from "./AdManagerAdmin.js?vue&type=script&lang=js&external"
export * from "./AdManagerAdmin.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports